<template lang="pug">
TheNewsSkeleton(v-if="newsQuery.isPending.value")

TheNotFound(v-else-if="error && error.statusCode === 404")
TheError(
  v-else-if="error"
  title="Failed to load news article."
  :message="error.message"
  :stack="error.stack"
  :reporting="{ message: error.message, extra: error }"
  @retry="newsQuery.refetch"
)

TheNewsView(
  v-else-if="news"
  :body-html="news.ss_body"
  :title="news.ss_title"
  :created="new Date(news.ds_created)"
  :changed="new Date(news.ds_changed)"
)

// TODO: This news item is not available in {{ commentLanguage }}. You can view it in the following languages …

TheNotFound(v-else)
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { injectRequired } from "~/injectRequired";
import { getStringParam } from "~/routing/routes";
import { LoggerKey, SolrClientKey } from "~/injectionKeys";
import { logSsrErrorToSentry } from "~/errors/util";
import { useNode } from "~/composables/useNode";

const solrClient = injectRequired(SolrClientKey);
const logger = injectRequired(LoggerKey);

const i18n = useI18n();
const route = useRoute();

const nid = computed(() => parseInt(getStringParam(route, "nid") || "0") || 0);

const newsQuery = useNode(
  solrClient,
  nid,
  i18n.locale,
  ["ss_title", "ss_body", "ds_changed", "ds_created"],
  "app_news",
  (e, s) => logSsrErrorToSentry(logger, e, s),
);

const news = computed(() => newsQuery.data.value?.value?.doc);
const availableLanguages = computed(
  () => newsQuery.data.value?.value?.languages ?? [],
);
const error = computed(
  () => newsQuery.error.value ?? newsQuery.data.value?.error ?? null,
);

onServerPrefetch(async () => {
  await newsQuery.suspense();
});
</script>
